import ArrowDropDownCircleOutlinedIcon from "@mui/icons-material/ArrowDropDownCircleOutlined";
import { Autocomplete, InputAdornment, Box, Stack, TextField, Typography, createFilterOptions } from "@mui/material";

export interface CounterpartyTypeOption {
  code: string;
  description: string;
}

interface Props {
  options: CounterpartyTypeOption[];
  value: CounterpartyTypeOption | null;
  onChange: (value: CounterpartyTypeOption | null) => void;
}

const filterOptions = createFilterOptions<CounterpartyTypeOption>({
  stringify: (option) => `${option.code} ${option.description}`.trim(),
});

const CounterpartyTypeFilter = ({ options, value, onChange }: Props) => {
  return (
    <Autocomplete
      size="small"
      value={value}
      options={options}
      onChange={(_, option) => onChange(option)}
      filterOptions={filterOptions}
      isOptionEqualToValue={(option, selected) => option.code === selected.code}
      getOptionLabel={(option) => option.code}
      noOptionsText="No counterparty types"
      sx={{ minWidth: 240 }}
      renderOption={({ key: _key, ...props }, option) => (
        <Box component="li" key={option.code} {...props}>
          <Stack direction="column">
            <Typography sx={{ whiteSpace: "nowrap" }}>{option.code}</Typography>
            <Typography color="textSecondary" sx={{ whiteSpace: "nowrap" }}>
              {option.description}
            </Typography>
          </Stack>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          slotProps={{
            ...params.slotProps,
            input: {
              ...params.slotProps.input,
              placeholder: "Counterparty Type",
              startAdornment: (
                <>
                  <InputAdornment position="start" sx={{ pl: 1 }}>
                    <ArrowDropDownCircleOutlinedIcon fontSize="small" color="action" />
                  </InputAdornment>
                  {params.slotProps.input.startAdornment}
                </>
              ),
            },
          }}
        />
      )}
    />
  );
};

export default CounterpartyTypeFilter;
